// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"dd1fb552","663":"dd1fb552","898":"dd1fb552"}[chunkId] + ".chunk.css";
};